import { Action } from '@ngrx/store';
import { SiteSettings } from 'src/app/shared/models/site-settings';
import { StrataResponse } from 'src/app/shared/models/strata-response';

export enum UIApproverActionTypes {
  APPROVER_SET_SUB_DOMAIN = '[UIApprover] Set Sub Domain',
  APPROVER_USER_LOGIN = '[UIApprover] Set Is Approver',
  APPROVER_SET_STRATA_PLAN_FRIENDLY_NAME = '[UIApprover] Set Strata Plan Friendly Name',
  APPROVER_FETCH_SITE_SETTINGS = '[UIApprover] Fetch Site Settings',
  APPROVER_FETCH_SITE_SETTINGS_SUCCESS = '[UIApprover] Fetch Site Settings Success',
  APPROVER_FETCH_SITE_SETTINGS_FAILURE = '[UIApprover] Fetch Site Settings Failure',
  ADMIN_USER_LOGIN = '[UIApprover] Set Is Not an Approver',
}

export class ApproverFetchSiteSettings implements Action {
  readonly type = UIApproverActionTypes.APPROVER_FETCH_SITE_SETTINGS;
  constructor(public payload: StrataResponse) { } // strataPlanNumber
}

export class ApproverFetchSiteSettingsSuccess implements Action {
  readonly type = UIApproverActionTypes.APPROVER_FETCH_SITE_SETTINGS_SUCCESS;
  constructor(public payload: SiteSettings) { }
}


export class ApproverSetSubDomain implements Action {
  readonly type = UIApproverActionTypes.APPROVER_SET_SUB_DOMAIN;
  constructor(public payload: string) { }
}

export class ApproverSetStrataPlanFriendlyName implements Action {
  readonly type = UIApproverActionTypes.APPROVER_SET_STRATA_PLAN_FRIENDLY_NAME;
  constructor(public payload: string) { }
}

export class ApproverSetIsNotApprover implements Action {
  readonly type = UIApproverActionTypes.ADMIN_USER_LOGIN;
}

export type UIApproverActions = ApproverSetSubDomain
  | ApproverSetStrataPlanFriendlyName
  | ApproverFetchSiteSettings
  | ApproverFetchSiteSettingsSuccess
  | ApproverSetIsNotApprover;
